/**
 * Device Detection Utility
 * Detects if user is browsing from a mobile device vs desktop/laptop
 */

export const isMobileDevice = () => {
  // Check user agent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  
  // Check screen size (mobile typically < 768px)
  const isSmallScreen = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
  
  // Check touch capability
  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Check if device is mobile based on multiple factors
  const isMobileUA = mobileRegex.test(userAgent);
  
  // Mobile if: mobile UA OR (small screen AND touch capable)
  return isMobileUA || (isSmallScreen && hasTouchScreen);
};

export const isIOSDevice = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isAndroidDevice = () => {
  return /Android/i.test(navigator.userAgent);
};

export const isDesktopDevice = () => {
  return !isMobileDevice();
};

